import Parties from "./Parties";
import Attachments from "./Attachments";
import ContractDetails from "./ContractDetails";
import Indexation from "./Indexation";
import ExistingDocument from "./ExistingDocument";
import Confirm from "./Confirm";
import SignStatus from "./SignStatus";
export default {
  PARTIES: Parties,
  EXISTINGDOC: ExistingDocument,
  ATTACHMENTS: Attachments,
  CONTRACT: ContractDetails,
  INDEXATION: Indexation,
  CONFIRM: Confirm,
  SIGN_STATUS: SignStatus,
};
